import { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';
import { getTermsAndPolicyConfig } from '../../../../config/config';
import { ORDER_STATUS } from '../../../../constants/constants';
import styles from './Checkboxes.module.scss';
import GetTermsAndPrivacy from '../../../../api/TermsAndPolicy';
import CheckboxesDataLayer from '../../../Analytics/Checkboxes/Checkboxes';
import { checkIfVilla } from '../../../../utils/OrderUtils';

function Checkboxes(props) {
  const { t } = useTranslation('common');
  const {
    order,
    onConfirmQuoteChange,
    onConfirmTermsChange,
    onReceiveOffersChange,
    confirmQuoteChecked,
    confirmTermsChecked,
    receiveOffersChecked,
  } = props;

  const termsAndPolicyConfig = getTermsAndPolicyConfig();

  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalTitle, setModalTitle] = useState('');

  useEffect(() => {
    Modal.setAppElement(document.body);
  }, []);

  const handleConfirmQuoteChange = (e) => {
    CheckboxesDataLayer('confirmQuoteDetails', !confirmQuoteChecked);
    onConfirmQuoteChange(e.target.checked);
  };

  const handleReceiveOffersChange = (e) => {
    CheckboxesDataLayer('agreeToReceiveOffers', !receiveOffersChecked);
    onReceiveOffersChange(e.target.checked);
  };

  const handleTermsChange = (e) => {
    CheckboxesDataLayer('agreeTermsClick', !confirmTermsChecked);
    onConfirmTermsChange(e.target.checked);
  };

  const handleVillaConditionsClick = (e) => {
    e.preventDefault();
    setModalTitle(t('villa-reservation-conditions'));
    setModalContent(termsAndPolicyConfig.villasConditions);
    setShowModal(!showModal);
  };

  const handleTermsClick = (e) => {
    e.preventDefault();
    setModalTitle(t('booking-conditions'));
    setModalContent(termsAndPolicyConfig.termsLink);
    setShowModal(!showModal);
  };

  const handlePrivacyClick = (e) => {
    e.preventDefault();
    setModalTitle(t('privacy-policy'));
    setModalContent(termsAndPolicyConfig.policyLink);
    setShowModal(!showModal);
  };

  const handleModalClose = (e) => {
    e?.preventDefault();
    setModalTitle('');
    setModalContent('');
    setShowModal(false);
  };

  return (
    <>
      {order.status === ORDER_STATUS.QUOTE ? (
        <div>
          <div>
            <input
              type="checkbox"
              checked={confirmQuoteChecked}
              onChange={handleConfirmQuoteChange}
            />
            {t('confirm-quote-details')}
            <span title="Required" className={styles.required}> *</span>
          </div>
        </div>
      ) : null}
      <div>
        <input type="checkbox" onChange={handleReceiveOffersChange} checked={receiveOffersChecked} />
        {t('i-would-like-to-receive-holiday-updates-offers-and')}
      </div>
      <div>
        <input type="checkbox" onChange={handleTermsChange} checked={confirmTermsChecked} />
        {t('i-agree-with-the')}
        {' '}
        <a href="#modal" onClick={handleTermsClick}>
          {t('booking-conditions')}
        </a>
        {checkIfVilla(order) && (
        <>
          {', '}
          <a href="#modal" onClick={handleVillaConditionsClick}>
            {t('villa-reservation-conditions')}
          </a>
        </>
        )}
        {' '}
        {t('and')}
        {' '}
        {t('the')}
        {' '}
        <a href="#modal" onClick={handlePrivacyClick}>
          {t('privacy-policy')}
        </a>
        <span title="Required" className={styles.required}> *</span>
      </div>
      <Modal
        isOpen={showModal}
        contentLabel={modalTitle}
        onRequestClose={handleModalClose}
      >
        <h2>{modalTitle}</h2>
        <div className={styles.leftText}>
          <GetTermsAndPrivacy id={modalContent} />
        </div>
        <button className={styles.close} type="button" onClick={handleModalClose}>{t('close')}</button>
      </Modal>
    </>
  );
}

export default Checkboxes;
